import { c as _c } from "react/compiler-runtime";
import type { DateDuration } from '@internationalized/date';
import { intlFormat } from 'date-fns/fp/intlFormat';
import { useHover, useLocale } from 'react-aria';
import { useDateRangePicker } from '../core/date-picker-provider';
import { Grid } from '../core/grid';
import { Row } from '../core/row';
import { calendarDateToDate } from '../core/to-calendar-date';
import { Day } from './day';
export type MonthProps = {
  offset?: DateDuration;
};
export function Month(t0) {
  const $ = _c(28);
  const {
    offset: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const offset = t2;
  const {
    state,
    onChange,
    pinnedAnchorDate,
    setPinnedAnchorDate,
    allowsNonContiguousRanges,
    initialHideRangeMarkers,
    isMobile,
    renderDate,
    weekDayLabel
  } = useDateRangePicker();
  const {
    locale
  } = useLocale();
  let t3;
  if ($[2] !== locale || $[3] !== weekDayLabel) {
    const formatIntl = intlFormat({
      locale
    });
    t3 = weekDayLabel ?? formatIntl({
      weekday: "short"
    });
    $[2] = locale;
    $[3] = weekDayLabel;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const renderWeekDay = t3;
  let t4;
  if ($[5] !== offset || $[6] !== state.visibleRange.start) {
    t4 = state.visibleRange.start.add(offset);
    $[5] = offset;
    $[6] = state.visibleRange.start;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const startDate = t4;
  let t5;
  if ($[8] !== onChange || $[9] !== setPinnedAnchorDate || $[10] !== state.anchorDate) {
    t5 = {
      onHoverChange: isHovered => {
        if (!isHovered && state.anchorDate) {
          onChange([calendarDateToDate(state.anchorDate), null]);
          setPinnedAnchorDate(state.anchorDate);
        }
      }
    };
    $[8] = onChange;
    $[9] = setPinnedAnchorDate;
    $[10] = state.anchorDate;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const {
    hoverProps
  } = useHover(t5);
  let t6;
  if ($[12] !== allowsNonContiguousRanges || $[13] !== initialHideRangeMarkers || $[14] !== isMobile || $[15] !== onChange || $[16] !== pinnedAnchorDate || $[17] !== renderDate || $[18] !== setPinnedAnchorDate || $[19] !== startDate || $[20] !== state) {
    t6 = week => <Row key={week} weekIndex={week} startDate={startDate} state={state}>{(date, i) => date ? <Day key={i} state={state} date={date} currentMonth={startDate} pinnedAnchorDate={pinnedAnchorDate} setPinnedAnchorDate={setPinnedAnchorDate} allowsNonContiguousRanges={allowsNonContiguousRanges} initialHideRangeMarkers={initialHideRangeMarkers} isMobile={isMobile} onChange={onChange} renderDate={renderDate} /> : <td key={i} />}</Row>;
    $[12] = allowsNonContiguousRanges;
    $[13] = initialHideRangeMarkers;
    $[14] = isMobile;
    $[15] = onChange;
    $[16] = pinnedAnchorDate;
    $[17] = renderDate;
    $[18] = setPinnedAnchorDate;
    $[19] = startDate;
    $[20] = state;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== hoverProps || $[23] !== renderWeekDay || $[24] !== startDate || $[25] !== state || $[26] !== t6) {
    t7 = <Grid startDate={startDate} state={state} tbodyProps={hoverProps} renderWeekDay={renderWeekDay}>{t6}</Grid>;
    $[22] = hoverProps;
    $[23] = renderWeekDay;
    $[24] = startDate;
    $[25] = state;
    $[26] = t6;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  return t7;
}